<template>
  <div class="introduce_right">
    <!-- <div class="introduce_right_top">
            <div class="due_title">即将到期</div>
            <div class="periodic_exam mar_top_15">阶段性考试</div>
            <div class="deadline">截止提交时间：2025/06/08 23:00</div>
            <div class="periodic_exam mar_top_30">阶段性考试</div>
            <div class="deadline">截止提交时间：2025/06/08 23:00</div>
        </div>
        <div class="introduce_right_top mar_top_20">
            <div class="due_title">最新更新</div>
            <div class="update_one" v-for="(item, index) in updateList" :key="index">{{ item.label }}</div>
        </div> -->
    <div class="school_right_top flex Flexalign mar_bottom_10">
      <el-image class="avatar" :src="imgPath(courseDetail.shopLogo)"></el-image>
      <div class="flex flexcolumn mar_left_10 flex-1 organization_info">
        <div class="flex Flexalign FlexBetween organization_info_top">
          <div class="organization_name toverflow">{{ courseDetail.shopName }}</div>
          <div class="collect_btn flex Flexalign Flexjustify cursor_pointer" v-if="!shopCollected"
            @click="collectShopCourse(true)">
            <el-image class="collect_icon" :src="imgPath('collect_icon.png')"></el-image>
            <div>关注</div>
          </div>
          <div class="flex btn btn_follow btn_followed Flexjustify Flexalign cursor_pointer" v-if="shopCollected"
            @click="collectShopCourse(false)">
            <div>已关注</div>
          </div>
        </div>
        <div class="organization_desc toverflows toverflow2">
          {{ courseDetail.shopBrief }}
        </div>
      </div>
    </div>
    <recommendCourseList></recommendCourseList>
  </div>
</template>

<script>
import recommendCourseList from "@/views/course/components/recommendCourseList.vue";
export default {
  name: "GjkcH5IntroduceRight",
  props: {
    courseDetail: {},
  },
  components: {
    recommendCourseList,
  },
  watch:{
    courseDetail:{
      handler(){
        this.getShopCollectInfo();
      },
      deep:true
    }
  },

  data() {
    return {
      updateList: [
        { label: "一元二次函数", value: 1 },
        { label: "集合与逻辑专题复习课件.pdf", value: 2 },
        { label: "一元二次函数、方程和不等式pptx", value: 3 },
        { label: "集合与逻辑专题复习课件.docx", value: 4 },
        { label: "一元二次函", value: 5 },
        { label: "集合与逻辑专题复习课件.docx", value: 6 },
      ],
      shopCollected: false, // 是否收藏机构
      collectParams: {
        collectType: 3,
        associatedIds: "",
      },
    };
  },

  mounted() { 
    this.getShopCollectInfo();
  },

  methods: {
    // 收藏机构
    collectShopCourse(flag) {
      this.$Api.shop.collectShop({ shopId: this.courseDetail.shopId }).then((res) => {
        console.log(res);
        if (flag) {
          this.$Dialog.toast("关注成功");
        } else {
          this.$Dialog.toast("已取消关注", { type: "warning" });
        }
        this.getShopCollectInfo();
      });
    },
    // 机构收藏关系
    getShopCollectInfo() {
      if(this.$Tools.empty(this.courseDetail)){
        return
      }
      this.collectParams.associatedIds = this.courseDetail.shopId;
      this.collectParams.collectType = 2;
      this.$Api.course
        .getCollectInfo(this.collectParams)
        .then((res) => {
          const idx = res.data.data.findIndex((item) => item == this.courseDetail.shopId);
          if (idx != -1) {
            this.shopCollected = true;
          } else {
            this.shopCollected = false;
          }
        })
        .catch(() => {
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.mar_top_15 {
  margin-top: 15px;
}

.mar_top_30 {
  margin-top: 30px;
}

.mar_top_20 {
  margin-top: 20px;
}

.introduce_right {
  .school_right_top {
    width: 330px;
    height: 97px;
    background: #ffffff;
    border-radius: 10px;
    padding: 10px 20px;
    box-sizing: border-box;

    .avatar {
      width: 54px;
      height: 54px;
      border-radius: 50%;
    }

    .organization_info {
      .organization_info_top {
        .organization_name {
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          max-width: 100px;
        }

        .collect_btn {
          width: 78px;
          height: 30px;
          background: linear-gradient(90deg, #00d5c2, #00d498);
          border-radius: 15px;
          line-height: 30px;
          text-align: center;
          color: #ffffff;

          .collect_icon {
            width: 18px;
            height: 18px;
            margin-right: 5px;
          }
        }

        .btn_followed {
          width: 94px;
          height: 36px;
          background: #f8f8f8;
          border-radius: 18px;
          color: #999999;
        }
      }

      .organization_desc {
        margin-top: 5px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #999999;
        line-height: 22px;
      }
    }
  }

  .introduce_right_top {
    width: 330px;
    // height: 187px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;

    .due_title {
      font-weight: bold;
      font-size: 18px;
      color: #111111;
    }

    .periodic_exam {
      color: #13d6aa;
    }

    .deadline {
      color: #999999;
      margin-top: 8px;
    }

    .update_one {
      color: #13d6aa;
      margin-top: 20px;
    }
  }
}
</style>